import React from 'react';
import { remove, isEqual, map, get, includes } from 'lodash';

// React view component to render
import { tableBlockRow as TableBlockRowView } from './tableBlockRow.view';

/**
 * @type {class}
 * @desc A React container/smart component to render a block-row view of a table's row
 * @example
 * import { TableBlockRow } from from './rowViews/TableBlockRow.container';
 *
 * // render
 * <TableBlockRow propName='propValue'/>
 */
export class TableBlockRow extends React.Component {

        /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        // table id
        this.data = {
            tableId: get( this.props, 'item.id' )
        };

        // selected row id's
        this.state = {
            selectedTableRows: []
        };

        this.handleSelection = this.handleSelection.bind( this );
        this.handleRowActionClick = this.handleRowActionClick.bind( this );
    }

      /**
     * @desc Handle search input change
     */
    handleSelection( { item, isChecked } ) {
        log.debug( 'TableBlockRow.handleSelection()' );

        // get the rows of the table
        const tableItems = get( this.props.item, 'values.items' );

        if( isChecked ) {
            this.setState( {
                selectedTableRows: [ ...this.state.selectedTableRows, item ]
            }, () => {

                /**
                 * if all the rows in the table are selected, select the table
                 * call the props.onSelect function with `isChecked: true`
                 */
                if( isEqual( this.state.selectedTableRows.length, tableItems.length )  ) {

                    this.props.onSelect( { item: this.data.tableId, isChecked: true } );
                }

            } );
        } else {
            const items = [ ...this.state.selectedTableRows ];

            remove( items, function( id ) {
                return isEqual( id,  item );
            } );

            this.setState( {
                selectedTableRows: [ ...items ]
            }, () => {

                /**
                 * if a row is un-selected, mark the table as `-` selected,
                 * call the props.onSelect function with `isChecked: false`
                 */
                if( 0 === this.state.selectedTableRows.length ) {
                    
                    this.props.onSelect( { item: this.data.tableId, isChecked: false } );

                }
            } );
        }
    }

    /**
     * @desc: function executed, when there is a change in the selectedRow list from the parent Table
     */
    updateTableRowSelection( nextProps ) {
        log.debug( 'TableBlockRow.updateTableRowSelection()' );
        
        if( includes( nextProps.selectedRows, this.data.tableId ) ) {
            
            // get the rows of the table
            const tableRows = get( this.props.item, 'values.items', [] );

            this.setState( {
                selectedTableRows: map( tableRows, row => {
                    return row.id;
                } )
            } );

        } else {
            this.setState( { selectedTableRows: [] } );
        }
    }

    handleRowActionClick( { type = 'column', value = {}, item = {} } = {} ) {
        log.debug( 'TableBlockRow.handleRowActionClick()' );

        const parentItem = {
            id: this.data.tableId
        };

        this.props.onActionClick( { type, value, item, parentItem } );

    }

    // when component will receive new props, update activeStepIndex
	UNSAFE_componentWillReceiveProps( nextProps ) {
        log.debug( 'TableBlockRow.componentWillReceiveProps()' );

		if( ! isEqual( this.props.selectedRows, nextProps.selectedRows ) ) {
            this.updateTableRowSelection( nextProps );
		}
    }

    /**
     * @desc Render overlay windows based on `state.windows` list
     */
    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <TableBlockRowView
                { ...this.props }
                selectedTableRows={ this.state.selectedTableRows }
                onRowSelection={ this.handleSelection }
                onRowActionClick = { this.handleRowActionClick }
            />
        );
    }
}

// set display name
TableBlockRow.displayName = 'TableBlockRow';

// set default props
TableBlockRow.defaultProps = {};

// prop types
TableBlockRow.propTypes = {};
